// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"19351":"c1f7de0082641d15","49984":"09b91b930688161b","51653":"897a0d3067692d47","53348":"a47f49226f1701d5"}[chunkId] + ".js";
};